export { default } from '@/features/auth/pages/ProfileActiveSessionPage'
